import {
  Coffee, UtensilsCrossed, Sandwich, Wine, Beer, IceCreamCone, Library, Palette, Drama, Film, Users, Store,
  Landmark, Image, Mountain, Brush, Star, Trees, Flower2, BookOpen, Ticket,
} from "lucide-react";

export const CATS = {
  cafe: { label: "Café", icon: Coffee },
  restaurant: { label: "Restaurant", icon: UtensilsCrossed },
  fast_food: { label: "Quick bite", icon: Sandwich },
  bar: { label: "Bar", icon: Wine },
  pub: { label: "Pub", icon: Beer },
  ice_cream: { label: "Ice cream", icon: IceCreamCone },
  library: { label: "Library", icon: Library },
  arts_centre: { label: "Arts centre", icon: Palette },
  theatre: { label: "Theatre", icon: Drama },
  cinema: { label: "Cinema", icon: Film },
  community_centre: { label: "Community space", icon: Users },
  marketplace: { label: "Market", icon: Store },
  museum: { label: "Museum", icon: Landmark },
  gallery: { label: "Gallery", icon: Image },
  viewpoint: { label: "Viewpoint", icon: Mountain },
  artwork: { label: "Public art", icon: Brush },
  attraction: { label: "Attraction", icon: Star },
  park: { label: "Park", icon: Trees },
  garden: { label: "Garden", icon: Flower2 },
  books: { label: "Bookstore", icon: BookOpen },
  anchor: { label: "Your activity", icon: Ticket },
};

export const catInfo = (c) => CATS[c] || { label: c, icon: Star };

export const PIN_COLORS = ["#2F7D55", "#B8892B", "#163A2B", "#4E8F3A", "#0E6E6E", "#7A6A1F", "#3F6F5A"];

export const INTERESTS = ["Coffee", "Food", "Art", "Museums", "Parks", "Nature walks", "Live music", "Movies", "Theatre",
  "Bookstores", "Libraries", "History", "Markets", "Nightlife", "Desserts", "Photography", "Architecture", "Community events"];
export const DISLIKES = ["Loud bars", "Crowds", "Long walks", "Expensive places", "Late nights", "Chain restaurants", "Touristy spots"];
export const VIBES = ["quiet", "social", "cultural", "outdoorsy", "romantic", "family-friendly", "adventurous"];
export const DIETS = ["Vegetarian", "Vegan", "Gluten-free", "Halal", "Kosher", "Dairy-free", "Nut allergy"];
export const ACCESS = ["Wheelchair", "Step-free", "Quiet spaces", "Seating breaks", "Stroller-friendly"];

export const BUDGETS = [
  { v: "free", l: "Free" }, { v: "low", l: "Under $20" }, { v: "medium", l: "$20–60" }, { v: "high", l: "$60+" },
];
export const TRANSPORT = [{ v: "walk", l: "Walk" }, { v: "bike", l: "Bike" }, { v: "transit", l: "Transit" }, { v: "car", l: "Car" }];
export const GROUPS = [{ v: "solo", l: "Solo" }, { v: "couple", l: "Couple" }, { v: "friends", l: "Friends" }, { v: "family", l: "Family" }];
export const DURATIONS = [1, 2, 3, 4, 6];

export const money = (lo, hi) => (hi === 0 ? "Free" : lo === hi ? `$${lo}` : `$${lo}–${hi}`);

export const nextTime = (addMin = 10) => {
  const d = new Date(Date.now() + addMin * 60000);
  const m = Math.ceil(d.getMinutes() / 5) * 5;
  d.setMinutes(m);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const defaultStart = () => {
  const t = nextTime(30);
  return t >= "08:00" && t <= "21:30" ? t : "10:00";
};
